import { Box } from "@mui/system";
import { Button } from "components/common/Buttons/MainButton";
import Spinner from "components/common/Spinner";
import { Dialog } from "primereact/dialog";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const QuizResults = ({ handleSubmit, submitting, displayModal, quizResults, onClose }) => {
  const { score, status, earnedPoints, totalPoints, results } = quizResults || {};

  return (
    <>
      <Button
        text={submitting ? "Enviando..." : "Enviar resultados"}
        click={handleSubmit}
        disabled={submitting}
      />
      {quizResults && (
        <Dialog
          header={false}
          visible={displayModal}
          modal={true}
          closable={false}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: { xs: "85vw", sm: "70vw", md: "50vw" },
            }}
          >
            {status === "APROBADO" ? (
              <>
                <CheckCircleOutlineIcon
                  sx={{
                    color: "#4dc95d",
                    fontSize: "5rem",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "2rem",
                    marginTop: "1rem",
                  }}
                >
                  ¡Felicidades! Has aprobado el quiz.
                </Typography>
              </>
            ) : (
              <>
                <HighlightOffIcon
                  sx={{
                    color: "#f21d41",
                    fontSize: "5rem",
                  }}
                ></HighlightOffIcon>
                <Typography
                  sx={{
                    fontSize: "2rem",
                    marginTop: "1rem",
                  }}
                >
                  Has reprobado, vuelve a intentarlo luego.
                </Typography>
              </>
            )}
            <Typography
              sx={{
                fontSize: "1.5rem",
                marginTop: "1rem",
                marginBottom: "1rem",
                fontWeight: "bold",
              }}
            >
              Puntaje: {score}/20 (obtuviste {earnedPoints} de {totalPoints} puntos)
            </Typography>
            
            {results && results.length > 0 && (
              <Box sx={{ width: "100%", marginBottom: "2rem" }}>
                <Typography
                  sx={{
                    fontSize: "1.2rem",
                    marginBottom: "1rem",
                    fontWeight: "bold",
                  }}
                >
                  Detalles por pregunta:
                </Typography>
                
                {results.map((result, index) => (
                  <Accordion key={index} sx={{ marginBottom: "0.5rem" }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        backgroundColor: result.isCorrect ? "#d4edda" : "#f8d7da",
                        border: `1px solid ${result.isCorrect ? "#c3e6cb" : "#f5c6cb"}`,
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                        {result.isCorrect ? (
                          <CheckCircleOutlineIcon
                            sx={{ color: "#28a745", marginRight: "8px", fontSize: "1.2rem" }}
                          />
                        ) : (
                          <HighlightOffIcon
                            sx={{ color: "#dc3545", marginRight: "8px", fontSize: "1.2rem" }}
                          />
                        )}
                        <Typography sx={{ flex: 1, fontSize: "0.9rem" }}>
                          Pregunta {index + 1}: {result.isCorrect ? "Correcta" : "Incorrecta"}
                        </Typography>
                        <Typography sx={{ fontSize: "0.8rem", color: "#666" }}>
                          {result.earnedPoints} de {result.points} puntos
                        </Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography variant="body2" sx={{ marginBottom: "8px", fontWeight: "bold" }}>
                        {result.question}
                      </Typography>
                      <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                        <strong>Tu respuesta:</strong> {result.userAnswer}
                      </Typography>
                      <Typography variant="body2" sx={{ color: result.isCorrect ? "#28a745" : "#dc3545" }}>
                        <strong>Respuesta correcta:</strong> {result.correctAnswer}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Box>
            )}
            
            <Button text={"Continuar el curso"} click={onClose}></Button>
          </Box>
        </Dialog>
      )}
    </>
  );
};
